import RxPrivateRoute from "./RxPrivateRoute";

export default RxPrivateRoute;
